import { useRouter } from 'next/router'
import { getToken, getUserData } from '../../utils/tokenStorage'

export default function LoginRedirect() {
  const router = useRouter()
  const token = getToken()

  if (typeof window !== 'undefined') {
    if (token) {
      const userData = getUserData(token)
      if (userData) {
        if (userData.type === 'Admin') {
          router.push('/admin/applications')
        } else if (userData.type === 'Breeder') {
          router.push('/breeder/dashboard')
        } else {
          router.push('/customer/dashboard')
        }
      }
    }
  }

  return null
}
